<template>
  <div class="content">
	<app-header></app-header>
	<div class="identityBg">
		<img src="../../assets/imgs/identityBg.png" alt="" />
	</div>
	<div class = "companyContent">
		<h2>单位主页设置</h2>
		<p class="companyLogo">
			<i class="editTitle"><span class="importants"></span>单位LOGO：</i>
			<label>
				<img v-bind:src="logo" alt="科研人才网-知名企业硕士博士科研人才招聘" />
				<input  type="file"  @change="uploadLOGO()" id="savebusinessLic" name="businessLic" />
			</label>
			<span class="advice">支持jpg、gif、png格式文件不超过10M</span> <span class="advice"> 为了更好的展示，建议上传70X70</span>
		</p>
		<p class="basicMsg">
			<i class="editTitle"><span class="importants">&lowast;</span>单位名称：</i>
			<input v-model = "companyName" placeholder="请输入单位名称" type="text" />
		</p>	
		<!-- <p class="basicMsg">
			<i class="editTitle"><span class="importants">&lowast;</span>单位类型：</i>
			<input v-model = "companyType" placeholder="请输入单位单位类型" type="text" />
		</p> -->
		<p class="basicMsg">
			<i class="editTitle"><span class="importantsDiff"></span>单位简称：</i>
			<input v-model = "shortName" type="text" placeholder="请输入单位简称" />
		</p>
		<p class="basicMsg">
			<i class="editTitle"><span class="importantsDiff"></span>单位网站：</i>
			<input v-model = "companyUrl" type="text" placeholder="请输入单位网站" />
		</p>
		<p class="basicMsg">
			<i class="editTitle"><span class="importantsDiff"></span>单位电话：</i>
			<input v-model = "telPhone" type="text" placeholder="请输入单位电话" />
		</p>
		<p class="basicMsg">
			<i class="editTitle"><span class="importants">&lowast;</span>单位地址：</i>
			<input v-model="companyAdd" type="text" placeholder="请输入单位地址" />
		</p>
		<!-- <p class="environment">
			<i class="editTitle"><span class="importantsDiff"></span>单位环境：</i>
			<span>
				<label>
					<img v-bind:src="companyEnvir1" alt="" />
					<input  type="file"  @change="uploadEnvir1()" id="uploadEnvir1" name="uploadEnvir1" />
				</label>
				<label>
					<img v-bind:src="companyEnvir2" alt="" />
					<input  type="file"  @change="uploadEnvir2()" id="uploadEnvir2" name="uploadEnvir2" />
				</label>
				<label>
					<img v-bind:src="companyEnvir3" alt="" />
					<input  type="file"  @change="uploadEnvir3()" id="uploadEnvir3" name="uploadEnvir3" />
				</label>
			</span>
			<span class="advice">支持jpg、gif、png格式文件不超过10M，建议上传380 X 180</span>
		</p> -->
		<p>			
			<i class="editTitle introduction">单位简介：</i>
			<editor id="editor_id" height="240px" width="680px" :content="editorText"
			        pluginsPath="/static/kindeditor/plugins/"
			        :loadStyleMode="false"
			        @on-content-change="onContentChange">
       			</editor>	
		</p>
		<p class="submitAdd"><span @click = "saveCompanyMsg">确认保存</span></p>
	</div>	
	<div class="ident">
		<app-footer></app-footer>
	</div>
  </div>
</template>




<script> 
import AppFooter from '../../components/common/footer.vue'
import AppHeader from '../../components/common/header1.vue'
import {get, postWithJson, form} from '@/api/services'
export default {
  	name: 'setCompany',
  	components: { AppFooter,AppHeader },
    data () {
    	return {
	        userId:'',//	  
	        id:'',//
			logo:require("../../assets/imgs/LOGOThumbnail.png"),
			logoFlag:false,
			companyName:'',//公司名称
			companyUrl:'',//公司网站
			shortName:'',//公司简称
			// companyType:"",//单位类型
			companyEnvir1:require("../../assets/imgs/addEnvironment.png"),
			companyEnvir2:require("../../assets/imgs/addEnvironment.png"),
			companyEnvir3:require("../../assets/imgs/addEnvironment.png"),//
			companyEnvir1Flag:false,
			companyEnvir2Flag:false,
			companyEnvir3Flag:false,
			editorText:'',//公司简介
			telPhone:'',//手机号
			email:'',//邮箱
			userName:'',
			noNowStatue:true,//是否通过认证

			cardNoSrc:require('../../assets/imgs/credentialsbg.png'),
			businessLic:require('../../assets/imgs/credentialsbg.png'),
      		companyAdd:'',// 公司地址
      		recruitmentName:'',//招聘者姓名
      		recruitmentPosition:'',//招聘者职务
      		telPhoneNo:'',//手机号
			businessLicFlag:false,//是否上传营业执照
      		cardNoSrcFlag:false,//是否上传身份证
    	}
	},
	mounted:function(){
		this.getCompanyInfo(); //获取userid
	},
  	methods:{
		getCompanyInfo:function(){
			let _self = this;
			_self.userName = localStorage.getItem('_userName');	
			postWithJson('front/user/getCompanyInfo',{email:_self.userName}).then(
				function(response) {
					if(response.data.status){
						let resData = response.data.data;
						_self.userId = resData.userId;
						_self.id = resData.id;
						_self.companyName = resData.name;
						_self.companyAdd =resData.address;
						_self.businessLic = resData.businessPhone||require('../../assets/imgs/credentialsbg.png');
						_self.recruitmentName = resData.contactName;
						_self.recruitmentPosition = resData.position;
						_self.telPhoneNo = resData.tel;
						_self.cardNoSrc = resData.certificate||require('../../assets/imgs/credentialsbg.png');

						_self.logo = resData.logo||require("../../assets/imgs/LOGOThumbnail.png");
						_self.shortName = resData.shortName;
						_self.companyUrl = resData.web;
						_self.telPhone = resData.tel;
						//  公司环境
						// if(resData.photo != null && resData.photo != "" && resData.photo != undefined){
						// 	let photoList = resData.photo.split(";")
						// 	if(photoList[0] != undefined){
						// 		_self.companyEnvir1 = photoList[0];
						// 		_self.companyEnvir1Flag = true;
						// 	}
						// 	if(photoList[1] != undefined){
						// 		_self.companyEnvir2 = photoList[1];
						// 		_self.companyEnvir2Flag = true;
						// 	}
						// 	if(photoList[2] != undefined){
						// 		_self.companyEnvir3 = photoList[2];
						// 		_self.companyEnvir3Flag = true;
						// 	}
						// }
						_self.editorText = resData.description;

					}else{
						_self.$message({
							message: response.data.message,
							type: 'error'
						});   
					}
				},
				function(response) {
					_self.$message({
						message: "请重试！",
						type: 'error'
					});            
				}
			)			
		},
		uploadLOGO:function(){  //公司LOGO
			let _self = this;
			let x = document.getElementById('savebusinessLic').files[0];
			let params = new FormData() ; //创建一个form对象
			params.append('file',x,x.name);  //append 向form表单添加数据
			let config = {
				headers:{'Content-Type':'multipart/form-data'}
			};
			postWithJson("front/common/upload",params,config)
				.then(function(response){
				if(response.data.code == 0){
						_self.logo = response.data.url;
						_self.logoFlag = true;
					}else{
						_self.$message({
							message: response.data.msg,
							type: 'error'
						}); 
					}          
				},
			function(response) {
				_self.$message({
					message: "请重试",
					type: 'error'
				}); 	
			})
		},
		// uploadEnvir1:function(){//公司环境
		// 	let _self = this;
		// 	let x = document.getElementById('uploadEnvir1').files[0];
		// 	let params = new FormData() ; //创建一个form对象
		// 	params.append('file',x,x.name);  //append 向form表单添加数据
		// 	let config = {
		// 		headers:{'Content-Type':'multipart/form-data'}
		// 	};
		// 	postWithJson("front/common/upload",params,config)
		// 		.then(function(response){
		// 		if(response.data.code == 0){
		// 				_self.companyEnvir1 = response.data.url;
		// 				_self.companyEnvir1Flag = true;
		// 			}else{
		// 				_self.$message({
		// 					message: response.data.msg,
		// 					type: 'error'
		// 				}); 
		// 			}          
		// 		},
		// 	function(response) {
		// 		_self.$message({
		// 			message: response.data.msg,
		// 			type: 'error'
		// 		});            
		// 	})
		// },	
		// uploadEnvir2:function(){//公司环境
		// 	let _self = this;
		// 	let x = document.getElementById('uploadEnvir2').files[0];
		// 	let params = new FormData() ; //创建一个form对象
		// 	params.append('file',x,x.name);  //append 向form表单添加数据
		// 	let config = {
		// 		headers:{'Content-Type':'multipart/form-data'}
		// 	};
		// 	postWithJson("front/common/upload",params,config)
		// 		.then(function(response){
		// 		if(response.data.code == 0){
		// 				_self.companyEnvir2 = response.data.url;
		// 				_self.companyEnvir2Flag = true;
		// 			}else{
		// 				_self.$message({
		// 					message: response.data.message,
		// 					type: 'error'
		// 				});
		// 			}          
		// 		},
		// 	function(response) {
		// 		_self.$message({
		// 					message: "请重试",
		// 					type: 'error'
		// 				});           
		// 	})
		// },
		// uploadEnvir3:function(){//公司环境
		// 	let _self = this;
		// 	let x = document.getElementById('uploadEnvir3').files[0];
		// 	let params = new FormData() ; //创建一个form对象
		// 	params.append('file',x,x.name);  //append 向form表单添加数据
		// 	let config = {
		// 		headers:{'Content-Type':'multipart/form-data'}
		// 	};
		// 	postWithJson("front/common/upload",params,config)
		// 		.then(function(response){
		// 		if(response.data.code == 0){
		// 				_self.companyEnvir3 = response.data.url;
		// 				_self.companyEnvir3Flag = true;
		// 			}else{
		// 				_self.$message({
		// 					message: response.data.msg,
		// 					type: 'error'
		// 				}); 
		// 			}          
		// 		},
		// 	function(response) {
		// 		_self.$message({
        //                 message: "请重试",
        //                 type: 'error'
        //             });            
		// 	})
		// },			
		saveCompanyMsg:function(){
			console.log()
			let logo = "";
			if(this.logo == require("../../assets/imgs/LOGOThumbnail.png")){
				logo = ""
			}else{
				logo = this.logo;
			}
			let _self = this;
			if(_self.companyName == ""){
				_self.$message({
					message: "请输入单位名称",
					type: 'error'
				}); 
				return false;
			} 
			if(_self.companyAdd == ""){
				_self.$message({
					message: "请输入所在城市",
					type: 'error'
				}); 
				// _self.$message.error("请输入所在城市");
				return false;
			}
			let environmentList = "";
			// if(_self.companyEnvir1Flag){
			// 	environmentList += _self.companyEnvir1;
			// }
			// if(_self.companyEnvir2Flag){
			// 	if(_self.companyEnvir1Flag){
			// 		environmentList += ','+_self.companyEnvir2;
			// 	}else{
			// 		environmentList += _self.companyEnvir2;
			// 	}
			// }
			// if(_self.companyEnvir3Flag){
			// 	if(_self.companyEnvir1Flag || _self.companyEnvir2Flag){
			// 		environmentList += ','+_self.companyEnvir3;
			// 	}else{
			// 		environmentList += _self.companyEnvir3;
			// 	}
			// }
			let datas = {
				id:_self.id,
				userId:_self.userId,
				contactName:_self.recruitmentName,//联系人姓名
				job:"",//职位
				name:_self.companyName,
				shortName:_self.shortName,
				tel:_self.telPhoneNo,
				email:_self.userName,
				logo:logo,
				web:_self.companyUrl,
				city:'',
				position:_self.recruitmentPosition,
				department:"",
				scale:'',
				stage:'',
				description:_self.editorText,
				businessPhone:_self.businessLic,
				address:_self.companyAdd,
				photo:environmentList,
				status:1,
				certificate:""
			}
			postWithJson('front/companyInfo/updateCompanyInfo',datas).then(
					function(response) {
					if(response.data.status){
						_self.$message({
							message: '您的信息已提交成功',
							type: 'success'
						});
						_self.$router.push({ path:'/companyCerter'})
					}else{
						_self.$message({
							message: response.data.message,
							type: 'error'
						}); 
					}
				},
				function(response) {
					_self.$message({
						message: response.data.message,
						type: 'error'
					});             
				}
			)
		},
		onContentChange (val) {
	      	this.editorText = val
	    },
			
  	},	
}
</script>

<style  lang = "less"  scoped="scoped">
//滚动条
::-webkit-scrollbar {
    width: 6px;
    height: 6px;
    background-color: #f1f1f1;
}

//滚动条轨道 
::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px #f1f1f1;
    -moz-box-shadow: inset 0 0 6px #f1f1f1;
    box-shadow: inset 0 0 6px #f1f1f1;
    background-color: #f1f1f1;
}

//滑块
::-webkit-scrollbar-thumb {
    -webkit-box-shadow: inset 0 0 6px #c1c1c1;
    -moz-box-shadow: inset 0 0 6px #c1c1c1;
    box-shadow: inset 0 0 6px #c1c1c1;
    border-radius: 3px;
    background-color: #c1c1c1;
}
.content{
	width: 100%;
	min-height: 150s0px;
	position: relative;
	background-color: #F4F4F4;
	.navs{
		background-color: white;
	}
	.identityBg{
		position: absolute;
		left: 0;
		right: 0;
		top: 80px;
		width: 100%;
		overflow: hidden;
	}
	.kindeditor-component{
		display: inline-block;
	}
	.header-right{
		height: 62px;
		line-height: 62px;	
		.head{
			width: 44px;
			height: 44px;
			border-radius: 50%;
			margin-top: 11px;
		}
		.header-msg{
			height: 44px;
			line-height: 20px;
			font-size: 12px;
			margin: 11px 12px 0;
			span{
				display: inline-block;
				height: 20px;
				line-height: 20px;
				margin: 0;
				color: #da251d;
				width: 26px;
			}
		}
		
	}
	.companyContent{
		width: 1020px;
		margin: 140px auto 60px;
		background-color: white;
		padding:20px 60px;
		position: absolute;
		left: 50%;
		margin-left:-510px;
		h2{
			font-size: 30px;
			color: #444;
			margin-top: 70px;
		}
		p{
			vertical-align: top;
			margin: 20px 0;
			font-size: 12px;
			color: #878787;
		}
		.companyLogo{
			vertical-align: top;
			label{
				display: inline-block;
				width: 72px;
				height: 66px;
				cursor: pointer;
			}
			i{
				vertical-align: top;
			}
			.advice{
				vertical-align: top;
				margin-left: 6px;
			}
			img{
				vertical-align: top;
				width: 72px;
				height: 66px;
			}
			input{
				visibility: hidden;
				width: 72px;
				height: 66px;
				border: none;
				background: url(../../assets/imgs/LOGOThumbnail.png) no-repeat 0 0;
			}
		}
		input[type = 'text']{
			width: 400px;
			height: 44px;
			border: none;
			background-color: #f8f8f8;
			text-indent: 10px;
		}
		select{
			width: 400px;
			height: 44px;
			border: none;
			background-color: #f8f8f8;
		}
		.editTitle{
			font-style: normal;
			font-size: 14px;
			color: #444;
			display: inline-block;
			width: 130px;
		}
		.introduction{
			vertical-align: top;
		}
		textarea{
			resize:none
		}
		.importants{
			color: red;
			margin-right: 4px;
		}
		.importantsDiff{
			margin-right: 9px;
		}
		.companyName{
			font-size: 16px;
			color: #444;
		}
		.environment{
			vertical-align: top;
			.editTitle{
				vertical-align: top;
			}			
			label{
				display: inline-block;
				width: 182px;
				height: 84px;
				cursor: pointer;
				margin-right: 10px;
			}
			img{
				width: 182px;
				height: 84px;
			}
			input{
				width: 0px;
				height: 0px;
				visibility: hidden;
			}
			.advice{
				display: inline-block;
				width: 170px;
				vertical-align: top;
			}
		}
		.submitAdd{
			text-align: center;
			span{
				display: inline-block;
				width: 282px;
				height: 52px;
				line-height: 52px;
				text-align: center;
				background-color: #DA251D;
				cursor: pointer;
				color: white;
				font-size: 20px;
			}
		}
	}	
}
.ident{
	margin-top: 1240px;
}
</style>



// WEBPACK FOOTER //
// src/views/companyRegister/setCompany.vue